
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.953 11L.703 2.75 3.06.393 13.667 11 3.06 21.607.703 19.25 8.953 11z"}})])
          )
        }
      }
    